import { c as _c } from "react/compiler-runtime";
import { useToasts } from '../components/common/Toast';
const fallbackCopyTextToClipboard = (text: string): Promise<boolean> => {
  return new Promise(resolve => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    let success;
    try {
      success = document.execCommand('copy');
    } catch (err) {
      success = false;
    }
    resolve(success);
  });
};
export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  // Write directly within the caller's user gesture. Deferring the write (e.g. via
  // setTimeout) drops WebKit's transient activation, so Safari rejects the clipboard
  // write — which previously escaped as an unhandled promise rejection. Always resolve
  // to a boolean and fall back on failure; never reject.
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // Clipboard API unavailable in this context (e.g. Safari outside a gesture); fall back.
    }
  }
  return fallbackCopyTextToClipboard(text);
};
export const useCopyToClipboard = () => {
  const $ = _c(2);
  const {
    addToast
  } = useToasts();
  let t0;
  if ($[0] !== addToast) {
    t0 = text => {
      copyTextToClipboard(text).then(success => addToast(success ? "success" : "error", success ? "Copied to clipboard" : "Failed to copy to clipboard")).catch(() => addToast("error", "Failed to copy to clipboard"));
    };
    $[0] = addToast;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};